module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec01_sp_fadcd5c6b498e31b680a0065c8d3d249.jpg";